export default __webpack_public_path__ + "static/media/DA.38247b4a.png";